export const KNOWN_ROLES = ['SuperAdmin', 'PlatformAdmin', 'Admin', 'SalesManager', 'Salgsleder', 'Sales', 'Researcher', 'Support', 'Finance', 'Viewer'];

const ROLE_LABELS = {
  Admin: 'Admin',
  SalesManager: 'Salgsleder',
  Salgsleder: 'Salgsleder',
  Sales: 'Selger',
  Researcher: 'Researcher / SDR',
  Support: 'Support',
  Finance: 'Finance',
  Viewer: 'Viewer',
  SuperAdmin: 'SuperAdmin',
  PlatformAdmin: 'PlatformAdmin'
};

export const CUSTOMER_ROLE_OPTIONS = [
  { value: 'Admin', label: ROLE_LABELS.Admin },
  { value: 'SalesManager', label: ROLE_LABELS.SalesManager },
  { value: 'Sales', label: ROLE_LABELS.Sales },
  { value: 'Researcher', label: ROLE_LABELS.Researcher },
  { value: 'Support', label: ROLE_LABELS.Support },
  { value: 'Finance', label: ROLE_LABELS.Finance },
  { value: 'Viewer', label: ROLE_LABELS.Viewer }
];

export const getRoleLabel = role => ROLE_LABELS[role] || `Ukjent rolle: ${role || 'mangler'}`;

export const isCustomerAssignableRole = role => CUSTOMER_ROLE_OPTIONS.some(
  option => option.value === role
);

export const isSystemRole = role => role === 'SuperAdmin' || role === 'PlatformAdmin';

export const isInternalTenant = activeTenant => {
  if (!activeTenant) return false;

  return (
    activeTenant.is_internal === true ||
    activeTenant.internal === true ||
    String(activeTenant.type || '').toLowerCase() === 'internal' ||
    String(activeTenant.plan || '').toLowerCase() === 'internal'
  );
};

export const getApplicationRole = (user, activeMembership) => {
  if (user?.isSuperAdmin || user?.appMetadataRole === 'SuperAdmin') {
    return 'SuperAdmin';
  }

  const membershipRole = activeMembership?.role;
  const metadataRole = user?.appMetadataRole;
  const userRole = user?.role;

  if (KNOWN_ROLES.includes(membershipRole) && membershipRole !== 'SuperAdmin') {
    return membershipRole;
  }

  if (KNOWN_ROLES.includes(metadataRole) && metadataRole !== 'SuperAdmin') {
    return metadataRole;
  }

  if (KNOWN_ROLES.includes(userRole) && userRole !== 'Customer') {
    return userRole;
  }

  return 'Sales';
};

export const getRolePermissions = (user, activeMembership, activeTenant) => {
  const role = getApplicationRole(user, activeMembership);
  const isSuperAdmin = role === 'SuperAdmin';
  const isAdmin = isSuperAdmin || role === 'Admin';
  const isSalesLeader = role === 'SalesManager' || role === 'Salgsleder';
  const isInternal = isInternalTenant(activeTenant);

  return {
    role,
    isSuperAdmin,
    canViewCRM: isAdmin ||
      isSalesLeader ||
      role === 'Sales' ||
      role === 'Researcher',
    canViewReports: isAdmin || isSalesLeader || role === 'Finance',
    canSettings: isAdmin,
    canImportBrreg: isAdmin ||
      isSalesLeader ||
      role === 'Researcher' ||
      (role === 'Sales' && isInternal),
    canOutreach: isAdmin ||
      isSalesLeader ||
      role === 'Sales' ||
      role === 'Researcher',
    canSwitchTenant: isSuperAdmin || role === 'Admin',
    canViewAll: isAdmin || isSalesLeader,
    canManageUsers: isSuperAdmin || role === 'Admin',
    canViewKnowledgeBase: true,
    canViewPipeline: isAdmin ||
      isSalesLeader ||
      role === 'Sales' ||
      (role === 'Researcher' && isInternal)
  };
};

export const hasRolePermission = (user, permission, activeMembership, activeTenant) => (
  Boolean(getRolePermissions(user, activeMembership, activeTenant)[permission])
);

export default getRolePermissions;